import { all } from 'redux-saga/effects';

import consultarDisponibilidadeMedicoPosto from './consultarDisponibilidadeMedicoPosto/saga';

export default all([consultarDisponibilidadeMedicoPosto]);
